import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../globals';
import { retry } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: 'my-auth-token'
  })
};

const httpOptionsMultipart = {
  headers: new HttpHeaders({
    'Accept': 'application/json',
    Authorization: 'my-auth-token'
  })
};

const httpAuthOnly = {
  headers: new HttpHeaders({
    'Authorization': 'my-auth-token'
  })
};

@Injectable()
export class InvApiService {
  private searchValue : string;
  //private searchValue = "InventorySearchValue";

  apiUrl = Globals.apiUrl;

  constructor(private http: HttpClient) { }

  setSearchValue(val) {
    this.searchValue = val;
    //sessionStorage.setItem(this.searchValue, JSON.stringify(val);
  }

  getSearchValue() {
    return this.searchValue;
    //return JSON.parse(sessionStorage.getItem(this.searchValue));
  }


  CreateInventoryDetails(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/CreateInventoryDetails',
      value,
      httpOptions
    );
  }

  UpdateInventoryDetails(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/UpdateInventoryDetails',
      value,
      httpOptions
    );
  }

  GetInventoryByID(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/GetInventoryByID',
      value,
      httpOptions
    );
  }

  GetLastUpdateHoursDate(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/GetLastUpdateHoursDate',
      value,
      httpOptions
    );
  }

  FillDivision() {
    return this.http.post<any>(
      this.apiUrl + 'UserService/FillDivision',
      '',
      httpOptions
    );
  }

  FillCategoryList() {
    return this.http.post<any>(
      this.apiUrl + 'CommonService/FillInventoryCategoryList',
      '',
      httpOptions
    );
  }

  FillManufacturerList(value) {
    return this.http.post<any>(
      this.apiUrl + 'CommonService/FillManufacturerList',
      value,
      httpOptions
    );
  }

  FillModels(value) {
    return this.http.post<any>(
      this.apiUrl + 'CommonService/FillModels',
      value,
      httpOptions
    );
  }

  FillVendorList() {
    return this.http.post<any>(
      this.apiUrl +
      'CommonService/FillVendors',
      '',
      httpOptions
    );
  }

  GetInventoryDetails(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/GetInventoryDetails',
      value,
      httpOptions
    );
  }

  GetInventoryNotes(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/GetInventoryNotes',
      value,
      httpOptions
    );
  }

  GetInventoryAttachments(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/GetInventoryAttachments',
      value,
      httpOptions
    );
  }

  DeleteInventoryDetail(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/DeleteInventoryDetail',
      value,
      httpOptions
    );
  }

  FileUpload(value) {
    return this.http.post<any>(
      Globals.apiUrl + 'Files/Upload',
      value,
      httpOptionsMultipart
    );
  }


  CreateModelDetails(value) {
    return this.http.post<any>(
      this.apiUrl +
      'MasterServiceController/CreateModelDetails',
      value,
      httpOptions
    );
  }

  GetScheduledHours(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/GetPMScheduledDetails',
      value,
      httpOptions
    );
  }

  CreateManufacturerDetails(value) {
    return this.http.post<any>(
      this.apiUrl +
      'MasterServiceController/CreateManufacturerDetails',
      value,
      httpOptions
    );
  }

  GetInventoryFilterDetails() {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/GetInventoryFilterDetails',
      '',
      httpOptions
    );
  }

  GetItemIdByInventory(value) {

    return this.http.post<any>(
      this.apiUrl + 'InventoryService/GetItemIdByInventory',
      value,
      httpOptions
    );
  }


  
  GetAllParts(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/GetAllParts',
      value,
      httpOptions
    );
  }

  CreatePartsQuantityByDivisionId(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/CreatePartsQuantityByDivisionId',
      value,
      httpOptions
    );
  }

  GetPartsQunatityByPartID() {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/GetPartsQuantityByPartID',
      httpOptions
    );
  }

   CreatePartsDivisionMapping(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/CreatePartsDivisionMapping',
      value,
      httpOptions
    );
  }

  GetPartsQuantityByDivision(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/GetPartsQuantityByDivision',
      value,
      httpOptions
    );
  }

GetSasUrl(containerName: string, uploadFilePath: string) {
  return this.http.post<any>(
    `${Globals.apiUrl}files/get-sas-url?containerName=${encodeURIComponent(containerName)}`,
    { uploadfilename: uploadFilePath },
    httpOptions
  );
}

  
  GetEquipmentDetailsBySerialNumber(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/GetEquipmentDetailsBySerialNumber',
      value,
      httpOptions
    );
  }

  GetPartsQuantityByDivisionID(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/GetPartsQuantityByDivisionID',
      value,
      httpOptions
    );
  }

    DeletePartQuantity(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/DeletePartQuantity',
      value,
      httpOptions
    );
  }

  GetInventoryPartList(value) {
    return this.http.post<any>(
      this.apiUrl +
      'InventoryService/GetInventoryPartList',
      value,
      httpOptions
    );
  }

      // ==================== IMPORT API (NEW) ====================

  /** Download Excel template (Blob) */
  DownloadPartTemplate() {
    // Casting responseType so HttpClient returns Observable<Blob>
    return this.http.get(
      `${this.apiUrl}InventoryService/templateParts`,
      {
        headers: new HttpHeaders({ 'Authorization': 'my-auth-token' }),
        responseType: 'blob' as 'json'
      }
    );
  }

    DownloadEquipmentTemplate() {
    // Casting responseType so HttpClient returns Observable<Blob>
    return this.http.get(
      `${this.apiUrl}InventoryService/templateEquipment`,
      {
        headers: new HttpHeaders({ 'Authorization': 'my-auth-token' }),
        responseType: 'blob' as 'json'
      }
    );
  }

  /** Commit import payload (JSON) */
  CommitImport(payload: {
    rowsToImport: any[];
    proceedSkippingDuplicates: boolean;
    emailAllFromExcel: boolean;
    allExcelEmails: string[];
    currentUserId;
  }) {
    return this.http.post<any>(
      `${this.apiUrl}InventoryService/SaveImportParts`,
      payload,
      httpAuthOnly // JSON
    );
  }

   ValidateImport(formData: FormData) {
    return this.http.post<any>(
      `${this.apiUrl}InventoryService/ImportInventoryValidate`,
      formData,
      httpAuthOnly // no 'Content-Type'
    );
  }

   ValidateEquipmentImport(formData: FormData) {
    return this.http.post<any>(
      `${this.apiUrl}InventoryService/ImportInventoryEquipmentValidate`,
      formData,
      httpAuthOnly // no 'Content-Type'
    );
  }

  /** Commit import payload (JSON) */
  SaveImportEquipments(payload: {
    rowsToImport: any[];
    proceedSkippingDuplicates: boolean;
    emailAllFromExcel: boolean;
    allExcelEmails: string[];
    currentUserId;
  }) {
    return this.http.post<any>(
      `${this.apiUrl}InventoryService/SaveImportEquipments`,
      payload,
      httpAuthOnly // JSON
    );
  }

  // ==================== EXISTING API ====================

  GetHX2DocumentsList(value) {
      return this.http.post<any>(
        this.apiUrl + 'InventoryService/GetHX2DocumentsList',
        value,
        httpOptions
      );
  }

  GetAllDocuments() {
    return this.http.post<any>(
        this.apiUrl + 'InventoryService/GetAllDocuments',
        httpOptions
      );
  }

  UploadDocumentByCategory(value) {
    return this.http.post<any>(
        this.apiUrl + 'InventoryService/UploadDocumentByCategory',
        value,
        httpOptions
      );
  }

}
